var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: "Nuevo Documento Predefinido",
        "hide-footer": "",
        centered: ""
      },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _vm._v(" ¿Qué tipo de documento quieres crear? ")
        ])
      ]),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _c("b-form-select", {
              attrs: { options: _vm.optionsTypeDocument },
              model: {
                value: _vm.type,
                callback: function($$v) {
                  _vm.type = $$v
                },
                expression: "type"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row pt-2" }, [
        _c(
          "div",
          { staticClass: "col-md-12 d-flex justify-end" },
          [
            _c(
              "vs-button",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: "Crear documento predefinido",
                    expression: "'Crear documento predefinido'"
                  }
                ],
                staticClass: "action mr-2",
                attrs: {
                  radius: "",
                  color: "primary",
                  disabled: _vm.type === "",
                  "data-cy": "create"
                },
                on: { click: _vm.goToForm }
              },
              [_vm._v("Crear")]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }